<!-- 文件中文名: 在线支付页面 -->
<template>
    <div class="pay-online app-container">
        <el-form ref="PayOnlineData" :model="PayOnlineData" label-position="right" label-width="auto" size="small"
            style="text-align: left">
            <div style="width: 50%;margin: 0 auto">
                <!--在线支付-->
                <h3>{{ $t('online.payment') }}</h3>
                <!--订单编号-->
                <el-form-item :label="$t('order.no')">
                    {{ PayOnlineData.orderNo }}
                </el-form-item>
                <!--总价格-->
                <el-form-item :label="$t('order.total.price')">
                    {{ PayOnlineData.totalAmount }} {{ $symbol() }}
                </el-form-item>
                <el-form-item>
                    <el-button :loading="btnLoading" class="filter-item" type="primary" @click="doPayOnline">
                        <!--支付-->
                        {{ $t('Common.pay') }}
                    </el-button>
                </el-form-item>
            </div>
        </el-form>
    </div>
</template>

<script>

import { memberOnlinePay } from "@/api/rus/api"
import { mapGetters } from "vuex";
export default {
    name: 'PayOnline',
    data() {
        return {
            orderNo: '',
            payMoney: '',
            PayOnlineData: {},
            btnLoading: false,
        }
    },
    computed: {
        ...mapGetters([
            'language',
            'userCode',
            'username',
            'companyCode',
        ]),
    },
    created() {
        if (!sessionStorage.getItem("PayOnlineData")) {
            console.log('PayOnlineData不存在!')
            this.$router.go(-1)
        }
        this.PayOnlineData = JSON.parse(sessionStorage.getItem("PayOnlineData"))
        console.log('PayOnlineData:', this.PayOnlineData);

    },
    methods: {
        doPayOnline() {
            this.btnLoading = true
            memberOnlinePay({ ...this.PayOnlineData }).then(res => {
                // console.log(res);
                window.location.replace(res.data.paymentRequestUrl)
            }).catch(err => {
                console.error(err)
                this.btnLoading = false
            })
        }
    }
}

</script>

<style scoped></style>
